export interface ValidationError {
  row: number;
  field: string;
  message: string;
  value?: any;
}

export function validateBulkUploadData(data: any[]): ValidationError[] {
  const errors: ValidationError[] = [];

  data.forEach((row, index) => {
    const rowNumber = index + 1;

    // Validar campos requeridos
    if (!row.anio || row.anio.trim() === "") {
      errors.push({
        row: rowNumber,
        field: "Año",
        message: "Campo requerido",
        value: row.anio,
      });
    }

    if (!row.unidad || row.unidad.trim() === "") {
      errors.push({
        row: rowNumber,
        field: "Unidad",
        message: "Campo requerido",
        value: row.unidad,
      });
    }

    if (!row.tema || row.tema.trim() === "") {
      errors.push({
        row: rowNumber,
        field: "Tema",
        message: "Campo requerido",
        value: row.tema,
      });
    }

    // Validar dificultad
    if (row.dificultad !== undefined && row.dificultad !== null) {
      const dificultad = row.dificultad.toString().toLowerCase().trim();

      // Si es un número, validar rango
      if (!isNaN(Number(row.dificultad))) {
        const numDificultad = Number(row.dificultad);
        if (numDificultad < 1 || numDificultad > 5) {
          errors.push({
            row: rowNumber,
            field: "Dificultad",
            message: "Debe ser un número entre 1 y 5",
            value: row.dificultad,
          });
        }
      } else {
        // Si es texto, validar que sea un concepto válido
        const conceptosValidos = [
          "básica",
          "basica",
          "básico",
          "basico",
          "muy fácil",
          "muy facil",
          "fácil",
          "facil",
          "media",
          "medio",
          "intermedia",
          "intermedio",
          "difícil",
          "dificil",
          "muy difícil",
          "muy dificil",
          "avanzada",
          "avanzado",
        ];

        if (!conceptosValidos.includes(dificultad)) {
          errors.push({
            row: rowNumber,
            field: "Dificultad",
            message:
              "Concepto no válido. Use números (1-5) o conceptos como 'Básica', 'Media', 'Difícil'",
            value: row.dificultad,
          });
        }
      }
    }

    // Validar tieneImagen
    if (row.tieneImagen !== undefined && row.tieneImagen !== null) {
      const tieneImagen = row.tieneImagen.toString().toLowerCase().trim();
      const valoresValidos = [
        "si",
        "sí",
        "no",
        "true",
        "false",
        "yes",
        "1",
        "0",
      ];

      if (!valoresValidos.includes(tieneImagen)) {
        errors.push({
          row: rowNumber,
          field: "Tiene Imagen",
          message: "Debe ser: Si/Sí/No, True/False, Yes/No, o 1/0",
          value: row.tieneImagen,
        });
      }
    }

    // Validar longitud de campos de texto
    if (row.objetivosAprendizaje && row.objetivosAprendizaje.length > 500) {
      errors.push({
        row: rowNumber,
        field: "Objetivos de Aprendizaje",
        message: "Máximo 500 caracteres",
        value: row.objetivosAprendizaje.substring(0, 50) + "...",
      });
    }

    if (row.explicacion && row.explicacion.length > 1000) {
      errors.push({
        row: rowNumber,
        field: "Explicación",
        message: "Máximo 1000 caracteres",
        value: row.explicacion.substring(0, 50) + "...",
      });
    }

    if (row.ejemplo && row.ejemplo.length > 500) {
      errors.push({
        row: rowNumber,
        field: "Ejemplo",
        message: "Máximo 500 caracteres",
        value: row.ejemplo.substring(0, 50) + "...",
      });
    }

    if (row.resultado && row.resultado.length > 500) {
      errors.push({
        row: rowNumber,
        field: "Resultado",
        message: "Máximo 500 caracteres",
        value: row.resultado.substring(0, 50) + "...",
      });
    }

    if (row.conceptosPrevios && row.conceptosPrevios.length > 500) {
      errors.push({
        row: rowNumber,
        field: "Conceptos Previos",
        message: "Máximo 500 caracteres",
        value: row.conceptosPrevios.substring(0, 50) + "...",
      });
    }
  });

  return errors;
}

export function processDificultad(dificultad: any): number {
  if (typeof dificultad === "number") {
    return Math.max(1, Math.min(5, Math.round(dificultad)));
  }

  if (typeof dificultad === "string") {
    const dificultadLower = dificultad.toLowerCase().trim();

    const mapeoDificultad: { [key: string]: number } = {
      básica: 1,
      basica: 1,
      básico: 1,
      basico: 1,
      "muy fácil": 1,
      "muy facil": 1,
      fácil: 2,
      facil: 2,
      media: 3,
      medio: 3,
      intermedia: 3,
      intermedio: 3,
      difícil: 4,
      dificil: 4,
      "muy difícil": 5,
      "muy dificil": 5,
      avanzada: 5,
      avanzado: 5,
    };

    return mapeoDificultad[dificultadLower] || 1;
  }

  return 1;
}

export function processTieneImagen(tieneImagen: any): boolean {
  if (typeof tieneImagen === "boolean") {
    return tieneImagen;
  }

  if (typeof tieneImagen === "string") {
    const valor = tieneImagen.toLowerCase().trim();
    return (
      valor === "si" ||
      valor === "sí" ||
      valor === "true" ||
      valor === "yes" ||
      valor === "1"
    );
  }

  if (typeof tieneImagen === "number") {
    return tieneImagen === 1;
  }

  return false;
}
